export const NAMESPACE_ITEMS = 'items'
export const NAMESPACE_INGREDIENTS = 'ingredients'
export const INGREDIENT_FEATURE = 'Ingredient Inventory'



// WEBPACK FOOTER //
// ./app/actions/inventory/constants.js